/**
 * Explicit icon imports for tree-shaking. Do not use `import *` from icon packages.
 * Regenerate: node scripts/generateUnifiedIconRegistry.mjs
 */

import {
  AppWindow,
  Archive,
  ArrowBendDownRight,
  ArrowClockwise,
  ArrowCounterClockwise,
  ArrowDownRight,
  ArrowLeft,
  ArrowLineLeft,
  ArrowLineRight,
  ArrowRight,
  ArrowSquareOut,
  ArrowUpRight,
  ArrowsMerge,
  ArrowsOut,
  ArrowsSplit,
  Bell,
  Binoculars,
  Book,
  BookOpen,
  Briefcase,
  Broadcast,
  Buildings,
  Calendar,
  CalendarBlank,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  ChartBar,
  ChartLine,
  ChartLineUp,
  ChartPie,
  ChatCircle,
  ChatCircleText,
  ChatsCircle,
  Check,
  CheckCircle,
  Circle,
  CircleNotch,
  ClipboardText,
  Clock,
  ClockCounterClockwise,
  ClockUser,
  Code,
  CodeBlock,
  Columns,
  ColumnsPlusLeft,
  ColumnsPlusRight,
  Confetti,
  Copy,
  CreditCard,
  DotsThree,
  DotsThreeOutline,
  DotsThreeOutlineVertical,
  DotsThreeVertical,
  Download,
  DownloadSimple,
  Envelope,
  Eraser,
  Eye,
  FileArrowUp,
  FilePdf,
  Files,
  Flag,
  FloppyDisk,
  Funnel,
  Gauge,
  Gear,
  GearSix,
  Globe,
  GoogleLogo,
  GraduationCap,
  GridFour,
  GridNine,
  HandTap,
  Handshake,
  Hash,
  Heart,
  Heartbeat,
  HouseLine,
  IdentificationBadge,
  Info,
  Leaf,
  LegoSmiley,
  Lightning,
  Link,
  LinkBreak,
  LinkedinLogo,
  List,
  ListBullets,
  ListNumbers,
  Lock,
  MagnifyingGlass,
  Mailbox,
  Medal,
  Megaphone,
  MicrosoftTeamsLogo,
  Minus,
  Moon,
  Newspaper,
  NotePencil,
  Palette,
  PaperPlaneTilt,
  Paperclip,
  Paragraph,
  Pause,
  Pencil,
  PencilSimple,
  PencilSimpleLine,
  Percent,
  Plant,
  Play,
  PlayCircle,
  PlugsConnected,
  Plus,
  ProjectorScreen,
  Pulse,
  PuzzlePiece,
  Question,
  Quotes,
  RadioButton,
  Robot,
  RocketLaunch,
  Rows,
  RowsPlusBottom,
  RowsPlusTop,
  Scales,
  ShareNetwork,
  ShieldCheck,
  SignOut,
  SlackLogo,
  Smiley,
  SmileyMeh,
  SmileySad,
  SmileyXEyes,
  Sparkle,
  Square,
  SquaresFour,
  Star,
  Stop,
  Strategy,
  SuitcaseSimple,
  Sun,
  Table,
  Target,
  TextAa,
  TextB,
  TextColumns,
  TextItalic,
  TextStrikethrough,
  Toolbox,
  Trash,
  TreeStructure,
  TrendUp,
  User,
  UserMinus,
  UserPlus,
  Users,
  UsersThree,
  Warning,
  WarningCircle,
  WhatsappLogo,
  WindowsLogo,
  X,
  XCircle
} from '@phosphor-icons/react';

/** @type {Record<string, import('react').ComponentType<any>>} */
export const phosphorIconRegistry = {
  AppWindow,
  Archive,
  ArrowBendDownRight,
  ArrowClockwise,
  ArrowCounterClockwise,
  ArrowDownRight,
  ArrowLeft,
  ArrowLineLeft,
  ArrowLineRight,
  ArrowRight,
  ArrowSquareOut,
  ArrowUpRight,
  ArrowsMerge,
  ArrowsOut,
  ArrowsSplit,
  Bell,
  Binoculars,
  Book,
  BookOpen,
  Briefcase,
  Broadcast,
  Buildings,
  Calendar,
  CalendarBlank,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  ChartBar,
  ChartLine,
  ChartLineUp,
  ChartPie,
  ChatCircle,
  ChatCircleText,
  ChatsCircle,
  Check,
  CheckCircle,
  Circle,
  CircleNotch,
  ClipboardText,
  Clock,
  ClockCounterClockwise,
  ClockUser,
  Code,
  CodeBlock,
  Columns,
  ColumnsPlusLeft,
  ColumnsPlusRight,
  Confetti,
  Copy,
  CreditCard,
  DotsThree,
  DotsThreeOutline,
  DotsThreeOutlineVertical,
  DotsThreeVertical,
  Download,
  DownloadSimple,
  Envelope,
  Eraser,
  Eye,
  FileArrowUp,
  FilePdf,
  Files,
  Flag,
  FloppyDisk,
  Funnel,
  Gauge,
  Gear,
  GearSix,
  Globe,
  GoogleLogo,
  GraduationCap,
  GridFour,
  GridNine,
  HandTap,
  Handshake,
  Hash,
  Heart,
  Heartbeat,
  HouseLine,
  IdentificationBadge,
  Info,
  Leaf,
  LegoSmiley,
  Lightning,
  Link,
  LinkBreak,
  LinkedinLogo,
  List,
  ListBullets,
  ListNumbers,
  Lock,
  MagnifyingGlass,
  Mailbox,
  Medal,
  Megaphone,
  MicrosoftTeamsLogo,
  Minus,
  Moon,
  Newspaper,
  NotePencil,
  Palette,
  PaperPlaneTilt,
  Paperclip,
  Paragraph,
  Pause,
  Pencil,
  PencilSimple,
  PencilSimpleLine,
  Percent,
  Plant,
  Play,
  PlayCircle,
  PlugsConnected,
  Plus,
  ProjectorScreen,
  Pulse,
  PuzzlePiece,
  Question,
  Quotes,
  RadioButton,
  Robot,
  RocketLaunch,
  Rows,
  RowsPlusBottom,
  RowsPlusTop,
  Scales,
  ShareNetwork,
  ShieldCheck,
  SignOut,
  SlackLogo,
  Smiley,
  SmileyMeh,
  SmileySad,
  SmileyXEyes,
  Sparkle,
  Square,
  SquaresFour,
  Star,
  Stop,
  Strategy,
  SuitcaseSimple,
  Sun,
  Table,
  Target,
  TextAa,
  TextB,
  TextColumns,
  TextItalic,
  TextStrikethrough,
  Toolbox,
  Trash,
  TreeStructure,
  TrendUp,
  User,
  UserMinus,
  UserPlus,
  Users,
  UsersThree,
  Warning,
  WarningCircle,
  WhatsappLogo,
  WindowsLogo,
  X,
  XCircle,
  Admin: ShieldCheck,
  DeviceFloppy: FloppyDisk,
};

/** @type {Record<string, import('react').ComponentType<any>>} */
export const tablerIconRegistry = {

};

export const ICON_REGISTRIES = {
  phosphor: phosphorIconRegistry,
  tabler: tablerIconRegistry,
};
